import { ASSIGNMENT_STATES, ASSIGNMENT_STATES_LOOKUP, ASSIGNMENT_STATUSES, ASSIGNMENT_STATUSES_LOOKUP } from './constants';

export const displayAssignmentStatus = (state, status) => {
    if(state === ASSIGNMENT_STATES.UNPUBLISHED || state === ASSIGNMENT_STATES.CANCELLED) {
        return ASSIGNMENT_STATES_LOOKUP[state];
    } else {
        return ASSIGNMENT_STATUSES_LOOKUP[status];
    }
};

export const stopAssignmentOrRemoveAssignment = (state, status) => {
    let allowStop = false;

    if(state === ASSIGNMENT_STATES.PUBLISHED) {
        allowStop = true;
    } else if(state === ASSIGNMENT_STATES.IN_PROGRESS && status !== ASSIGNMENT_STATUSES.NO_PROGRESS) {
        allowStop = true;
    } else if(state === ASSIGNMENT_STATES.COMPLETED) {
        allowStop = true;

    }

    return allowStop;
};



// WEBPACK FOOTER //
// ./src/containers/AssignmentsPage/utils.js